import React, { useMemo } from 'react';

const lunaStyles = `
  @keyframes lunaFloat {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-6px); }
  }
  @keyframes lunaGlow {
    0%, 100% { box-shadow: 0 0 0px rgba(111, 66, 193, 0); }
    50% { box-shadow: 0 0 18px 6px rgba(111, 66, 193, 0.55); }
  }
  .luna-moon-emoji {
    animation: lunaFloat 3s ease-in-out infinite;
    display: inline-block;
    font-size: 48px;
    border-radius: 50%;
    animation: lunaFloat 3s ease-in-out infinite, lunaGlow 3s ease-in-out infinite;
    line-height: 1;
    user-select: none;
  }
`;

function getTimeGreeting(hours, name) {
  if (hours >= 5 && hours < 12) {
    return `Good morning, ${name}! Ready for tonight's story?`;
  } else if (hours >= 12 && hours < 18) {
    return `Good afternoon, ${name}! Tonight's adventure awaits ✨`;
  } else if (hours >= 18 && hours < 21) {
    return `Good evening, ${name}! Perfect time to start a story 🌙`;
  } else {
    return `Bedtime magic time, ${name}! Luna is ready ⭐`;
  }
}

const LunaMascot = ({ user, streakData }) => {
  const greeting = useMemo(() => {
    if (!user) return '';
    const firstName = (user.name || 'friend').split(' ')[0];
    const hours = new Date().getHours();
    return getTimeGreeting(hours, firstName);
  }, [user]);

  if (!user) return null;

  const currentStreak = streakData?.currentStreak || 0;

  return (
    <>
      <style>{lunaStyles}</style>
      <div
        style={{
          background: 'var(--purple-section)',
          border: '1px solid var(--border-purple)',
          borderRadius: '16px',
          padding: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <div className="luna-moon-emoji" role="img" aria-label="Luna the moon mascot">
          🌙
        </div>
        <div>
          <div
            style={{
              fontFamily: "'Fredoka One', cursive",
              fontSize: '18px',
              color: 'var(--text-main)',
              lineHeight: 1.3,
            }}
          >
            {greeting}
          </div>
          {currentStreak > 0 && (
            <div
              style={{
                fontSize: '13px',
                color: 'var(--text-muted2)',
                marginTop: '4px',
              }}
            >
              Luna is proud — {currentStreak}-night streak! 🔥
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LunaMascot;
